<script lang="ts">
  import { css } from '@agapi/ui/panda/css';
  import { calculateSizes, generateSrcSet, generateFormattedSrc } from './image-utils.svelte';
  import type { ImageProps } from './image.types';

  const {
    src,
    alt,
    width,
    height,
    aspectRatio,
    fit = 'cover',
    background,
    loading = 'lazy',
    decoding = 'async',
    sizes,
    fetchpriority = 'auto',
    css: cssProp
  }: ImageProps = $props();

  const computedHeight = $derived(aspectRatio ? width / aspectRatio : height);

  let srcset = $derived(generateSrcSet(src, width, height, fit));
  let formattedSrc = $derived(generateFormattedSrc(src, width, height, fit));
  let calculatedSizes = $derived(calculateSizes(width, sizes));

  let imageLoaded = $state(false);
  let imageRef: HTMLImageElement | undefined = undefined;

  $effect(() => {
    imageLoaded = false;
    if (imageRef?.complete) {
      handleImageLoad();
    }
  });

  const imageStyles = css.raw({
    objectPosition: 'center',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    overflow: 'hidden',
    transition: 'filter 0.09s ease-in-out',
    clipPath: 'inset(0)'
  });

  const handleImageLoad = () => {
    imageLoaded = true;
  };
  // console.log('background', background);
</script>

<img
  bind:this={imageRef}
  src={formattedSrc}
  srcset={srcset}
  sizes={calculatedSizes}
  alt={alt}
  width={width}
  height={computedHeight}
  loading={loading}
  decoding={decoding}
  fetchpriority={fetchpriority}
  class={css(imageStyles, cssProp)}
  style:filter={imageLoaded ? 'blur(0px)' : 'blur(9px)'}
  style:aspect-ratio={aspectRatio}
  style:object-fit={fit}
  style:background-size={fit}
  style:background-image="{background && !imageLoaded ? `url(${background})` : 'none'}"
  onload={handleImageLoad}
/>
